import script from "./forgetPasswordPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./forgetPasswordPage.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__